import { Link } from 'react-router-dom';
import { prefixPath } from '../../../utils/helpers';

interface props {
  path: string,
  name: string,
  theme: string
}
const RightButtons = ({ theme, name, path }: props) => {
  const imgSubPath = window.location.origin;
  const addImg = imgSubPath + prefixPath(`/img/${theme}/Add Workspace.png`);
  return (
    <Link to={path} style={{ textDecoration: 'none' }}>
      <button type="button" className="ms-2 btn comingSoon">
        <img src={addImg} alt="" className="me-1" />
        <span className="">
          {name}
        </span>
      </button>
    </Link>

  );
};

export default RightButtons;